export default __webpack_public_path__ + "static/media/lowpool.57ac55ad.jpg";